module.exports = __webpack_public_path__ + "1555904a3ed0f25d93fafb91d409d99e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/2.jpg
// module id = 225
// module chunks = 0